import type { BadgeStatus } from '@athena/ui'

interface PracticeCardData {
  publishedVersion: { id: string } | null
  assignedStudents: ReadonlyArray<{ id: string }>
}

/**
 * Draft, published, or published and in someone's list. The badge is the only
 * place a tutor sees the difference at a glance, so it is derived in one place
 * and used by every screen that shows a card.
 *
 * Archived is deliberately not here: it is a separate axis, and a practice can
 * be archived while still being published and assigned. The caller that cares
 * checks `archived` first.
 */
export function practiceStatus(practice: PracticeCardData): BadgeStatus {
  if (!practice.publishedVersion) return 'draft'
  return practice.assignedStudents.length > 0 ? 'assigned' : 'published'
}
